import React, { Component } from 'react';
import { formatNumber } from '../helpers/helpers.js';
import './spine.css';

class Spine extends Component {
  constructor(props) {
    super(props);
    this.draw = this.draw.bind( this );
    
    this.state = {
      section: [ 0, 0 ]
    }
  }

  componentDidMount() {
    this.draw();
  }
	
	componentWillUnmount() {}

  draw() {
    let total = this.props.data[0].value + this.props.data[1].value;
    console.log( total );
    let section = [];
    section.push( ( this.props.data[0].value * 100 / total ) );
    section.push( ( this.props.data[1].value * 100 / total ) );
    this.setState( { section } );
  }


  render() {
    return (
      <div className="spine">
        <div className="in">
          <header className="spine--title">
            {this.props.title}
          </header>
          <div className="spine--header">
            <div className="spine--section">
              <h2>{this.props.data[0].title}</h2>
            </div>
            <div className="spine--section">
              <h2>{this.props.data[1].title}</h2>
            </div>
          </div>
          <div className="spine--body">
            <div className="spine--section section-0">
              <div className="in">
                <div className="spine--section--bar" style={{ width: this.state.section[0] + '%' }}>{(this.state.section[0] > 10) ? formatNumber(this.props.data[0].value) : ''}</div>
              </div>
            </div>
            <div className="spine--section section-1">
              <div className="in">
                <div className="spine--section--bar" style={{ width: this.state.section[1] + '%' }}>{(this.state.section[1] > 10) ? formatNumber(this.props.data[1].value) : ''}</div>
              </div>
            </div>
          </div>
          <footer className="spine--description">{this.props.description}</footer>
        </div>
      </div>
    );
  }
}

export default Spine;


// WEBPACK FOOTER //
// ./src/Elezioni/charts/spine.js